<template>
  <div>
    <van-cell-group title="审批人" :border="true" size="large">
      <!-- <div v-for="(items,index) in approvers" :key="index" > -->
        <div class="approvers" v-for="(items,index) in approvers" :key="index">
          <van-row type="flex" justify="center" class="approver">
            <van-col span="8" v-for="approver in items" :key="approver.id">
              <van-image
                round
                width="4rem"
                height="4rem"
                :src="approver.thumb_avatar"
              />
              <h3>{{approver.name}}</h3>
              <p>{{approver.position}}</p>
            </van-col>

          </van-row>
          
        <van-divider />
        </div>
  </van-cell-group>
    
  </div>
</template>

<script>
export default {
  name: 'Approver',
  props: {
    approvers:Array,

  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.approvers{
  text-align: 0 auto;
  /* display:block; */
  /* margin:10px; */
}
.approver{
  padding:10px;

}
.van-steps--vertical{

}
.approver .van-step{
  display:block;

}
h3 {
  font-size:12px;
  margin:5px;
}
p{
  margin:0px;
  font-size:12px;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
.van-cell-group__title{
  background-color:#3f51b5 ;
  font-size:14px;
  font-weight:blod;
  color:white;
  padding:13px;

}
</style>
